import styled from 'styled-components'
import { ScrollbarStyle } from '../../../../../../styles/components/scrollbar'
import { theme } from '../../../../../../styles/theme'
import { Button } from '../styles'

export const Container = styled.div`
  padding: 10px 25px 30px;
`

export const QRCodeWrapper = styled.div`
  margin-bottom: 10px;

  & > img {
    width: 100%;
  }
`

export const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const DownloadButton = styled(Button)`
  background: ${theme.colors.blue};
`

export const PrintButton = styled(Button)`
  background: ${theme.colors.mediumGray};
`

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 999;

  display: flex;
  align-items: center;
  justify-content: center;

  background: ${theme.colors.overlay.primary};
`

export const Modal = styled.div`
  max-height: 90vh;
  width: 100%;
  max-width: 378px;

  overflow: hidden;


  background: ${theme.colors.mainBg};
  border-radius: ${theme.border.smallRadius};


  & > main {
    max-height: 80vh;
    overflow-x: hidden;
    overflow-y: auto;
    padding 25px;

    ${ScrollbarStyle}
  }

`

export const Header = styled.div`
  width: 100%;
  height: 70px;
  padding: 22px 24px;

  background-color: ${theme.colors.secondLightGray};

  display: flex;
  align-items: center;
  justify-content: space-between;

  & > h1 {
    font-size: ${theme.font.sizes.large};
    font-weight: ${theme.font.normal};
    line-height: ${theme.font.sizes.xlarge};
    color: ${theme.colors.brown};
  }

  & > button {
    background: none;
  }
`
